import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "np-visited-articles";

function getVisited(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

let listeners: Array<() => void> = [];

function notify() {
  listeners.forEach((fn) => fn());
}

export function markVisited(slug: string) {
  try {
    const visited = getVisited();
    visited.add(slug);
    // Keep only the last 500 to avoid localStorage bloat
    const arr = [...visited].slice(-500);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    notify();
  } catch {}
}

export function useVisitedArticles() {
  const [visited, setVisited] = useState<Set<string>>(getVisited);

  useEffect(() => {
    const update = () => setVisited(getVisited());
    listeners.push(update);
    return () => {
      listeners = listeners.filter((fn) => fn !== update);
    };
  }, []);

  const isVisited = useCallback((slug: string) => visited.has(slug), [visited]);

  return { isVisited };
}
